import type { ReactElement } from 'react';
import type { LivingBriefDetail } from '@shared/api';

/** Non-blocking companion to the workspace: missing facts stay visible while
 * the seller can continue reviewing and editing the draft. */
export function DetailsNeededPanel({
  details,
  onPrefill,
  onFocusPage,
  onClose,
}: {
  details: LivingBriefDetail[];
  onPrefill: (text: string) => void;
  onFocusPage: (pageId: string) => void;
  onClose: () => void;
}): ReactElement {
  const missing = details.filter((detail) => detail.status === 'missing');
  return (
    <section className="details-needed-panel" aria-label="Details needed">
      <header><div><strong>Details needed</strong><span>Draft stays editable while you finish these.</span></div><button type="button" className="details-needed-close" onClick={onClose} aria-label="Close details needed">Close</button></header>
      {missing.map((detail) => <div className="details-needed-row" key={detail.key}>
        <div><strong>{detail.label}</strong><span>{detail.placeholder}</span></div>
        <div>{detail.affectedPageIds.slice(0, 2).map((pageId) => <button type="button" key={pageId} onClick={() => onFocusPage(pageId)}>View page</button>)}</div>
        <button type="button" onClick={() => onPrefill(`Update ${detail.label}: `)}>Add detail</button>
      </div>)}
    </section>
  );
}
